<nz-result nzStatus="info" nzTitle="404" nzSubTitle="Error! Page not found" [nzIcon]="icon" >
  <div nz-result-extra>
    <p>For some reason the page you requested could not be found on our server</p>
    <p><a [routerLink]="[]" id="back" (click)="goBack()">&laquo; Go Back</a> / <a id="home" routerLink="/">Go Home&raquo;</a></p>
  </div>
</nz-result>
<ng-template #icon>
  <i nz-icon nzType="question-circle" nzTheme="fill"></i>
</ng-template>
